import Frequencies from './components/Frequencies';

export default Frequencies;
